var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssetBreakdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 6.0002C1.2002 4.72716 1.70591 3.50626 2.60608 2.60608C3.50626 1.70591 4.72716 1.2002 6.0002 1.2002V6.0002H10.8002C10.8002 7.27323 10.2945 8.49413 9.39431 9.39431C8.49413 10.2945 7.27323 10.8002 6.0002 10.8002C4.72716 10.8002 3.50626 10.2945 2.60608 9.39431C1.70591 8.49413 1.2002 7.27323 1.2002 6.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 1.35156C8.03037 1.56664 8.78792 1.99983 9.39432 2.60623C10.0007 3.21264 10.4339 3.97019 10.649 4.80036H7.2002V1.35156Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetBreakdownIcon);
export default __webpack_public_path__ + "static/media/asset-breakdown-icon.b44eb8ef0f0059d75fa387fcbc86e34f.svg";
export { ForwardRef as ReactComponent };